import cn from 'classnames';
import { Input } from '#components/atoms/forms/input/Input.tsx';
import styles from './EndpointOIDCUsersSearch.module.css';

type Props = {
  value: string;
  onChange: (value: string) => void;
  /** Fill the header's column when it stacks, instead of the fixed row width. */
  fullWidth?: boolean;
  className?: string;
};

export function EndpointOIDCUsersSearch({ value, onChange, fullWidth = false, className }: Props) {
  return (
    <div
      className={cn(
        styles.EndpointOIDCUsersSearch,
        { [styles.EndpointOIDCUsersSearch___fullWidth]: fullWidth },
        className
      )}
    >
      <svg
        className={styles.EndpointOIDCUsersSearch_icon}
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="6.5" cy="6.5" r="5" />
        <line x1="10" y1="10" x2="14.5" y2="14.5" />
      </svg>
      <Input
        type="search"
        placeholder="Search users"
        aria-label="Search users"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={styles.EndpointOIDCUsersSearch_input}
      />
    </div>
  );
}
